import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
};

export default function SectionTitle({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  children,
}: SectionTitleProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] font-medium uppercase tracking-[0.24em] text-accent-600">
            <span className="inline-block h-px w-6 bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-3">
        {children}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            {actionLabel}
            <i className="ri-arrow-right-line text-[14px]" />
          </Link>
        )}
      </div>
    </div>
  );
}